import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { WaveDivider } from './ui/WaveDivider';
export function OfferBlock() {
  return <section id="offer-section" className="relative bg-deep-teal text-white pt-24 pb-10 mt-4 overflow-hidden" data-id="element-157">
      <WaveDivider position="top" fill="#ffffff" className="absolute top-0 left-0 w-full -mt-[1px]" data-id="element-158" />

      {/* Decorative background elements */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full max-w-4xl h-full bg-gold/10 blur-3xl rounded-full -z-0" data-id="element-159"></div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 pt-12 text-center" data-id="element-160">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-161">
          <h2 className="text-4xl md:text-5xl font-bold mb-6 text-white" data-id="element-162">
            Take back control of your body today.
          </h2>
          <p className="text-xl text-white/90 mb-12 max-w-2xl mx-auto" data-id="element-163">
            Forget the diets that make you miserable and embrace a solution that
            works with you, not against you.
          </p>

          <div className="bg-white/10 backdrop-blur-md border border-white/20 p-8 md:p-12 rounded-3xl max-w-2xl mx-auto shadow-2xl" data-id="element-164">
            <div className="mb-8" data-id="element-165">
              <span className="text-cream/80 line-through text-xl mr-3" data-id="element-166">
                $47.00 USD
              </span>
              <span className="block text-gold font-bold text-sm tracking-widest uppercase mt-2 mb-2" data-id="element-167">
                Special Launch Price
              </span>
              <div className="text-5xl md:text-6xl font-bold text-white mb-1" data-id="element-168">
                $9.39 <span className="text-2xl font-normal" data-id="element-169">USD</span>
              </div>
              <span className="inline-block text-xs font-bold tracking-wide bg-white/15 border border-white/25 text-white px-2.5 py-0.5 rounded-md mb-2" data-id="element-170">
                79% OFF
              </span>
              <p className="text-cream/80 text-sm" data-id="element-171">(One-Time Payment)</p>
            </div>

            <Button variant="gold" pulse className="w-full py-5 text-xl mb-4 shadow-[0_0_30px_rgba(197,165,90,0.4)]" onClick={() => {
            if (typeof window.fbq === 'function') {
              window.fbq('track', 'AddToCart', {
                content_name: 'The Nighttime Cortisol Code',
                content_ids: ['51859779191066'],
                content_type: 'product',
                value: 17.0,
                currency: 'USD'
              });
            }
            window.location.href = 'https://innershiftstore.com/cart/51859779191066:1';
          }} data-id="element-172">
              Yes — Send Me The Cooling Code Tonight!
            </Button>

            <p className="text-sm text-cream/80 flex items-center justify-center gap-2" data-id="element-173">
              <svg className="w-4 h-4 text-green-400" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-174">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" data-id="element-175"></path>
              </svg>
              Secure Checkout • Instant Digital Access • Start tonight
            </p>
            <p className="text-sm text-gold/90 text-center mt-2" data-id="element-176">
              🛡️ 30-Day Money Back Guarantee — No questions asked
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}